import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal, Tag } from "rsuite";
import { AuthorizationStatus, serviceTypes } from "../../Constants/types";
import format_number from "../../Helpers/number_formatter";
import moment from "moment";
import { useRecoilValue } from "recoil";
import { CCAsAtom } from "../../Atoms/cca.atom";
import Grid from "../../Components/Grid";
import { OperationTypeAtom } from "../../Atoms/operationTypes.atom";
import { APi } from "../../Api";
import { showReceipt } from "../../Helpers/showReceipt";

export default function ListTransactions({ show, close, verify, data = [] }) {
  const operationTypes = useRecoilValue(OperationTypeAtom);
  const ccas = useRecoilValue(CCAsAtom);
  const [clients, setclients] = useState([]);
  const [clientsB2C, setClientB2C] = useState([]);
  const [referrersData, setReferrersData] = useState([]);

  useEffect(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/GetAllInfoB2C")
      .fetchAll()
      .then((res) => {
        setClientB2C(res.data);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }, []);

  useEffect(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Client, {}, "/autocomplete")
      .customGet()
      .then((res) => {
        setclients(res.data);
      });
  }, []);

  const columns = [
    {
      value: "sequentialNumber",
      value2: "errorTransactionId",
      value3: "correctionTransactionId",
      name: "N.P",
      render: (nb, errorTransactionId, correctionTransactionId) => (
        <h6
          style={{
            fontSize: "12px",
            position: "relative",
            paddingleft: "10px",
            color:
              errorTransactionId || correctionTransactionId
                ? "rgb(229, 57, 53)"
                : "",
          }}
        >
          {errorTransactionId || correctionTransactionId ? (
            <span
              style={{
                background: "rgb(229, 57, 53)",
                color: "rgb(229, 57, 53)",
                width: "8px",
                height: "48px",
                display: "block",
                position: "absolute",
                left: "-10px",
                content: " ",
                top: "-8px",
              }}
            ></span>
          ) : (
            ""
          )}
          {nb}
          {errorTransactionId || correctionTransactionId ? (
            <span
              style={{
                color: "rgb(229, 57, 53)",
                fontSize: "10px",
                display: "block",
                lineHeight: "11px",
              }}
            >
              {errorTransactionId ? "Correction" : "Erreur"}{" "}
            </span>
          ) : (
            ""
          )}{" "}
        </h6>
      ),
    },
    {
      value: "date",
      name: "Date",
      value2: "authorizationStatus",
      value3: "givedAuthorizationBy",

      render: (v, v2, givedAuthorizationBy) => (
        <h6
          style={{
            fontSize: "12px",
          }}
        >
          {moment(v).format("DD MMM YYYY")}
          <br></br>
          {v2 && v2 != 1 ? (
            <Tag
              size="sm"
              color={v2 == 2 ? "yellow" : v2 == 3 ? "green" : "red"}
            >
              <i
                style={{
                  fontWeight: "300",
                  fontSize: "12px",
                }}
              >
                {AuthorizationStatus.find((el) => el.value == v2)
                  ? AuthorizationStatus.find((el) => el.value == v2).label
                  : "-"}
                *9
                <i
                  style={{
                    color: "#f1f1f1",
                    fontSize: "12px",
                    display: "block",
                    marginTop: 0,
                  }}
                >
                  {ccas &&
                  givedAuthorizationBy &&
                  ccas.find((el) => el.id == givedAuthorizationBy)
                    ? ccas.find((el) => el.id == givedAuthorizationBy).name
                    : ""}
                </i>
              </i>
            </Tag>
          ) : (
            ""
          )}
        </h6>
      ),
    },
    {
      value: "representative",
      name: "Représentant",
      render: (v) => {
        return (
          <div
            style={{ maxWidth: "160px", overflow: "auto", fontSize: "13px" }}
          >
            {v ? v.toUpperCase() : "-"}
          </div>
        );
      },
    },
    {
      value: "operationTypeId",
      name: "Type",
      render: (v) =>
        v ? (
          <b
            style={{
              color: [
                "#330033",
                "#3c1053",
                "#334455",
                "#140d2e",
                "#334455",
                "#5a2c3e",
              ][operationTypes.findIndex((_) => _.id == v) / 6],
            }}
          >
            {operationTypes.find((el) => el.id == v)
              ? operationTypes.find((el) => el.id == v).designation
              : "Autres"}
          </b>
        ) : (
          "-"
        ),
    },
    {
      value: "debit",
      name: "Débit",
      render: (v) => (
        <b style={{ fontSize: "14px", color: "#549f0a" }}>
          {v ? format_number(v) : ""}
        </b>
      ),
    },
    {
      value: "credit",
      name: "Crédit",
      render: (v) => (
        <b style={{ fontSize: "14px" }}>{v ? format_number(v) : ""}</b>
      ),
    },

    {
      value: "designation",
      name: "designation",
      render: (v) => {
        return (
          <div
            style={{ maxWidth: "240px", overflow: "auto", fontSize: "13px" }}
          >
            {v ? v.toUpperCase() : "-"}
          </div>
        );
      },
    },
    {
      value: "checkout",
      name: "Caisse",
      render: (v) => (
        <b style={{ color: "#4c67c2" }}>
          {v && v.name ? v.name.toUpperCase() : "-"}
        </b>
      ),
    },

    {
      value: "service",
      name: "Service",
      render: (v) =>
        v ? (
          <Tag
            color={
              v == 1
                ? "blue"
                : v == 2
                ? "green"
                : v == 3
                ? "red"
                : v == 4
                ? "black"
                : v == 5
                ? "orange"
                : v == 6
                ? "violet"
                : v == 7
                ? "yellow"
                : "teal"
            }
          >
            {serviceTypes.find((el) => el.value == v)
              ? serviceTypes.find((el) => el.value == v).label
              : "Autres"}
          </Tag>
        ) : (
          "-"
        ),
    },
  ];

  const fetchReferrers = useCallback(() => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction + "/GetAllReferrer", {})
      .customGet()
      .then((res) => {
        setReferrersData(res.data);
      });
  }, []);

  useEffect(() => {
    fetchReferrers();
  }, [fetchReferrers]);

  const handlePrint = (id) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Transaction)
      .fetchById(id)
      .then((res) => {
        let m = {
          ...res.data,
        };
        showReceipt(m, operationTypes, clientsB2C, clients, referrersData);
      });
  };
  return (
    <div>
      {show ? (
        <Modal
          size="l"
          overflow={false}
          style={{
            maxHeight: "calc(100vh - 50px)",
            overflow: "auto",
            width: "90vw",
            margin: "auto",
          }}
          open={show}
          onClose={close}
        >
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <div style={{ maxHeight: "calc(100vh - 240px)", overflow: "auto" }}>
              {verify ? (
                <div style={{ textAlign: "right", padding: "15px 0" }}>
                  {" "}
                  <Button onClick={verify} color="green" appearance="primary">
                    Vérifier
                  </Button>
                </div>
              ) : (
                " "
              )}
              <Grid
                rows={data}
                columns={columns}
                printAction={(id) => handlePrint(id)}
                actionKey="id"
                noAdvancedActions
                actions={[]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={close} appearance="subtle">
              Annuler
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        ""
      )}
    </div>
  );
}
